/** Espelha os DTOs do backend (internal/dto/dto.go). */

export type LampCondition = 'APAGADA' | 'SEMPRE_ACESA' | 'INTERMITENTE';

export const LAMP_CONDITION_LABELS: Record<LampCondition, string> = {
  APAGADA: 'Lâmpada apagada',
  SEMPRE_ACESA: 'Lâmpada sempre acesa',
  INTERMITENTE: 'Piscando / intermitente',
};

export const REQUEST_STATUS_LABELS: Record<string, string> = {
  PENDENTE: 'Em análise',
  APROVADA: 'Aprovada',
  REJEITADA: 'Rejeitada',
};

export const ORDER_STATUS_LABELS: Record<string, string> = {
  ABERTA: 'Aberta',
  AVULSA: 'Avulsa',
  EM_ANALISE: 'Em Análise',
  EM_ANDAMENTO: 'Em andamento',
  PENDENTE: 'Pendente',
  CONCLUIDA: 'Concluída',
  EM_ATRASO: 'Em atraso',
};

export interface PublicOrderRequestCreateInput {
  reporterName: string;
  cpf: string;
  birthDate: string;
  email: string;
  whatsapp: string;
  poleBusbar: string;
  logradouro: string;
  numero: string;
  complemento?: string;
  bairro: string;
  referencePoint?: string;
  lampCondition: LampCondition;
  latitude: number;
  longitude: number;
  description?: string;
  photoUrl?: string;
  turnstileToken: string;
  isAdult: boolean;
  dataIsTrue: boolean;
  acceptsPrivacyPolicy: boolean;
}

export interface CreateResponse {
  protocolNumber: string;
  message: string;
}

export interface TrackByProtocolInput {
  protocolNumber: string;
  turnstileToken: string;
}

export interface TrackByProtocolResponse {
  protocolNumber: string;
  reporterName?: string;
  orderStatus: string;
  address: string;
  neighborhood: string;
  poleBusbar?: string;
  openedAt?: string;
  createdAt: string;
}

export interface TrackByCPFInput {
  cpf: string;
  birthDate: string;
  turnstileToken: string;
}

export interface TrackByCPFItem {
  protocolNumber: string;
  reporterName?: string;
  orderStatus: string;
  address: string;
  neighborhood: string;
  poleBusbar?: string;
  openedAt?: string;
  createdAt: string;
}

export interface TrackByCPFResponse {
  items: TrackByCPFItem[];
}
